// Caminho do legado (`/gestao-carteira/parcelamentos`), num arquivo sem dependências: a porta (`public.ts`)
// o entrega a Cobranças e a Operações sem levar os filtros e os enums de Parcelamentos junto.
export const INSTALLMENT_PATH = '/gestao-carteira/parcelamentos';
export const installmentPath = (id: string) => `${INSTALLMENT_PATH}/${encodeURIComponent(id)}`;
